import { LayoutDefinitionSchema } from "./v1";

const layoutSchemas = [LayoutDefinitionSchema];

export class UnsupportedLayoutSchemaVersion extends Error {
  constructor(schemaVersion: number, options?: ErrorOptions) {
    super(`Schema version ${schemaVersion} is unsupported`, options);
    this.name = "UnsupportedLayoutSchemaVersion";
  }
}

/**
 * Returns the schema for the given schema version
 * @throws {UnsupportedLayoutSchemaVersion} if the schema version is unsupported
 */
export function getLayoutSchema(schemaVersion: number) {
  // Schema versions are indexed from 1
  const schema = layoutSchemas[schemaVersion - 1];

  if (schema === undefined) {
    throw new UnsupportedLayoutSchemaVersion(schemaVersion);
  }

  return schema;
}
